import { DraftFutureLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { areExpirationsEqual } from './expiration-utils';

export default function instrumentView(
  expiration: DraftFutureLeg['expiration'],
  instruments: UnifiedInstruments['futureInstruments'],
) {
  const instrument = instruments.find((ins) =>
    areExpirationsEqual(ins.expiration, expiration),
  );
  return [instrument?.name, instrument?.id] as const;
}
